import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_303: DocMigration = {
  maxSchemaVersion: "0.0.303",
  description:
    "Foundation patterns from static room layout and stair blocks to doc. RENAMING doc field from roomEdgeBehaviors to edgeBehaviors.",
  apply(json: any): any {
    const entityEdgeBehaviors: { [id: string]: any } = {};

    let count = Object.keys(json.roomEdgeBehaviors).length;

    for (const roomId in json.staticRoomLayouts) {
      const staticRoomLayout = json.staticRoomLayouts[roomId];
      if (!staticRoomLayout) {
        continue;
      }

      const foundationPatterns = staticRoomLayout?.foundationPatterns;
      if (!foundationPatterns?.length) {
        // I realize this can orphan empty arrays, but staticRoomLayout will get removed in 8th and final migration of this set.
        continue;
      }

      for (const foundationPattern of foundationPatterns) {
        const id = uid();
        entityEdgeBehaviors[id] = {
          ...foundationPattern,
          entityType: "EDGE_BEHAVIOR",
          edgeBehaviorType: "FOUNDATION_PATTERN",
          sortIndex: count++,
          parentId: roomId,
          id,
        };
      }

      delete staticRoomLayout.foundationPatterns;
    }

    for (const stairBlockId in json.stairBlocks) {
      const stairBlock = json.stairBlocks[stairBlockId];
      const foundationPatterns = stairBlock?.foundationPatterns;
      if (!foundationPatterns?.length) {
        delete stairBlock.foundationPatterns;
        continue;
      }

      for (const foundationAssembly of foundationPatterns) {
        const id = uid();
        entityEdgeBehaviors[id] = {
          ...foundationAssembly,
          entityType: "EDGE_BEHAVIOR",
          edgeBehaviorType: "FOUNDATION_PATTERN",
          sortIndex: count++,
          parentId: stairBlock.id,
          id,
        };
      }

      delete stairBlock.foundationPatterns;
    }

    json.edgeBehaviors = { ...json.roomEdgeBehaviors, ...entityEdgeBehaviors };

    delete json.roomEdgeBehaviors;

    return json;
  },
};

export default migration_0_0_303;
